import { useEffect } from "react";
import {
    saveProgress,
    getCompletedCount
} from "../services/progress";
import {
    saveJournalEntry
} from "../services/journal";
import {
    trackActivityStarted,
    trackActivityCompleted
} from "../utils/analytics";
import { useState } from "react";
import { modules } from "../data/modules";
import { useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { InAppReview } from "@capacitor-community/in-app-review";

export default function IframeActivity({
    src,
    title,
    height = "1200"
}) {
    const activityId = src
        .replace("/activities/", "")
        .replace("/index.html", "");
    const navigate = useNavigate();
    const REVIEW_KEY = "reviewPromptShown";

    useEffect(() => {



        trackActivityStarted(activityId);

    }, [activityId]);

    useEffect(() => {

        window.scrollTo(0, 0);

        async function handleMessage(event) {
            console.log("Message received:", event.data);
            const data = event.data;

            if (!data) {
                return;
            }

            if (data.type === "activityEnded") {

                const activities = modules.flatMap(
                    module => module.activities
                );

                const index = activities.findIndex(
                    activity => activity.id === data.activityId
                );

                const next =
                    index >= 0
                        ? activities[index + 1] ?? null
                        : null;
                console.log("Next activity:", next);

                const iframe =
                    document.querySelector("iframe");

                if (next) {

                    console.log("Posting nextActivity to iframe");

                    iframe?.contentWindow?.postMessage(
                        {
                            type: "nextActivity",
                            id: next.id,
                            title: next.title
                        },
                        "*"
                    );

                } else {

                    console.log("No next activity - returning home");

                    iframe?.contentWindow?.postMessage(
                        {
                            type: "returnHome"
                        },
                        "*"
                    );

                }

                return;
            }

            if (data.type === "goToNextActivity") {

                navigate(`/activity/${data.activityId}`);

                return;

            }
            if (data.type === "goHome") {

                navigate("/");

                return;

            }

            await saveProgress(
                data.activityId,
                {
                    score: data.score,
                    bestScore: data.score
                }
            );
            if (
                Capacitor.isNativePlatform() &&
                !localStorage.getItem(REVIEW_KEY)
            ) {
                const completedCount =
                    await getCompletedCount();

                if (completedCount >= 8) {

                    localStorage.setItem(
                        REVIEW_KEY,
                        "true"
                    );
                    try {

                        await InAppReview.requestReview();

                    } catch (error) {

                        console.error(
                            "Unable to request review:",
                            error
                        );

                    }

                }
            }

            console.log("Saving journal entry:", data);

            await saveJournalEntry(
                data.activityId,
                {
                    moduleId: data.moduleId,
                    activityId: data.activityId,
                    activityTitle: data.activityTitle,
                    summaryTitle: data.summaryTitle,
                    summary: data.summary,
                    result: data.result,
                    score: data.score,
                    metadata: data.metadata
                }
            );

            console.log("Journal save finished");
            trackActivityCompleted(
                data.activityId,
                data.score
            );

            console.log("Saved:", data.activityId);


        }

        window.addEventListener(
            "message",
            handleMessage
        );

        return () => {

            window.removeEventListener(
                "message",
                handleMessage
            );

        };

    }, [src]);

    return (
        <>
            <iframe
                src={src}
                title={title}
                width="100%"
                height={height}
                style={{
                    border: "none"
                }}
            />



        </>
    );
}